import moment from 'moment'
import { date } from 'quasar'

// let createStartDate = function () {
//   let today = moment(new Date())
//     .format('YYYY-MM-DD HH:mm')
//   return today
// }

const startDate = () => {
  const newDate = date.formatDate(date.buildDate(Date.now(), { hours: 0, minutes: 0, seconds: 0 }), 'YYYY-MM-DD HH:mm:ss')
  return newDate
}

const endDate = () => {
  const newDate = date.formatDate(date.addToDate(Date.now(), { year: 10 }), 'YYYY-MM-DD HH:mm:ss')
  return newDate
}

const getDatetime = function (date) {
  return moment(date)
    .format('YYYY-MM-DD HH:mm:ss')
}

class Assignment {
  constructor (_assignment) {
    if (typeof _assignment !== 'undefined') {
      const rolelist = []
      const signaturelist = []
      if (_assignment.roles) {
        _assignment.roles.forEach(role => {
          rolelist.push(role.id)
        })
      }
      if (_assignment.signature_roles) {
        _assignment.signature_roles.forEach(role => {
          signaturelist.push(role.id)
        })
      }

      this.id = _assignment.id ? _assignment.id : null
      this.rrule = _assignment.rrule ? _assignment.rrule : 'FREQ=DAILY;INTERVAL=1;BYHOUR=13;BYMINUTE=7;BYDAY=MO,TU,WE,TH,FR,SA,SU'
      this.company_standard = _assignment.company_standard ? _assignment.company_standard : null
      this.consolided_value = _assignment.consolided_value ? _assignment.consolided_value : null
      this.start_date = _assignment.start_date ? getDatetime(_assignment.start_date) : startDate()
      this.end_date = _assignment.end_date ? getDatetime(_assignment.end_date) : endDate()
      this.close_at_end_month = _assignment.close_at_end_month ? _assignment.close_at_end_month : 0
      this.close_at_end_periodicity = _assignment.close_at_end_periodicity ? _assignment.close_at_end_periodicity : 1
      this.supervision = _assignment.supervision ? _assignment.supervision : null
      this.supervisor_role = _assignment.supervisor_role ? _assignment.supervisor_role : null
      this.audited_role = _assignment.audited_role ? _assignment.audited_role : null
      this.notification_missed = _assignment.notification_missed ? _assignment.notification_missed : 0
      this.notification_below_standard = _assignment.notification_below_standard ? _assignment.notification_below_standard : 0
      this.notification_closed_checklist = _assignment.notification_closed_checklist ? _assignment.notification_closed_checklist : 0
      this.notification_closed_checklist_by_rol = _assignment.notification_closed_checklist_by_rol ? _assignment.notification_closed_checklist_by_rol : 0
      this.notification_push_missed = _assignment.notification_push_missed ? _assignment.notification_push_missed : 0
      this.notification_push_below_standard = _assignment.notification_push_below_standard ? _assignment.notification_push_below_standard : 0
      this.roles = _assignment.roles ? rolelist : null
      this.published = _assignment.published ? _assignment.published : 0
      this.restricted_by_area = _assignment.restricted_by_area ? _assignment.restricted_by_area : 0
      this.by_event = _assignment.by_event ? _assignment.by_event : 1
      this.by_calendar = _assignment.by_calendar ? _assignment.by_calendar : 0
      this.self_manage = _assignment.self_manage ? _assignment.self_manage : 0
      this.external_emails = _assignment.external_emails ? _assignment.external_emails : []
      this.external_push_notifications = _assignment.push_notifications ? _assignment.push_notifications : []
      this.franchise_id = _assignment.franchise_id !== 0 ? _assignment.franchise_id : 0
      this.no_score = _assignment.no_score ? _assignment.no_score : 0
      this.auto_ap = _assignment.auto_ap ? _assignment.auto_ap : 0
      this.validate_tables = _assignment.validate_tables ? _assignment.validate_tables : 0
      this.signature_check = _assignment.signature_check ? _assignment.signature_check : 0
      this.signature_roles = _assignment.signature_roles ? signaturelist : null
      this.leadership_check = _assignment.leadership_check ? _assignment.leadership_check : 0
      this.hide_pending_tasks = _assignment.hide_pending_tasks ? _assignment.hide_pending_tasks : 0
      this.aditional_signature_check = _assignment.aditional_signature_check ? _assignment.aditional_signature_check : 0
      this.additional_signatures = _assignment.additional_signatures ? _assignment.additional_signatures : 0
      this.additional_signatures_required = _assignment.additional_signatures_required ? _assignment.additional_signatures_required : 0
      this.user_editor_id = _assignment.user_editor_id ? _assignment.user_editor_id : null
      this.authorized_users = _assignment.authorized_users ? _assignment.authorized_users : []
    } else {
      this.id = null
      this.rrule = 'FREQ=DAILY;INTERVAL=1;BYHOUR=13;BYMINUTE=7;BYDAY=MO,TU,WE,TH,FR,SA,SU'
      this.company_standard = 0
      this.consolided_value = 0
      this.close_at_end_month = 0
      this.close_at_end_periodicity = 1
      this.start_date = startDate()
      this.end_date = endDate()
      this.roles = null
      this.supervision = null
      this.supervisor_role = null
      this.audited_role = null
      this.notification_missed = 0
      this.notification_closed_checklist = 0
      this.notification_closed_checklist_by_rol = 0
      this.notification_below_standard = 0
      this.notification_push_missed = 0
      this.notification_push_below_standard = 0
      this.published = 0
      this.restricted_by_area = 0
      this.by_event = 1
      this.by_calendar = 0
      this.self_manage = 0
      this.external_emails = []
      this.external_push_notifications = []
      this.franchise_id = null
      this.no_score = 0
      this.auto_ap = 0
      this.validate_tables = 0
      this.signature_check = 0
      this.signature_roles = null
      this.leadership_check = 0
      this.aditional_signature_check = 0
      this.additional_signatures = 0
      this.additional_signatures_required = 0
      this.user_editor_id = null
      this.authorized_users = []
    }
  }
}

export default Assignment
